import IBlob from "../models/IBlob";
import IErrorResponse from "../models/networking/IErrorResponse";
import networkService from "./networkService";

class FileService {

    /**
     * @description Get the upload URL for the file
     * @param {IBlob} blob Information about the file to upload
     */
    async getUploadUrl(blob: IBlob): Promise<IBlob> {
        const response = await networkService.post<IBlob, IBlob>("/file/url", blob);

        if (!response.isSuccessful)  {
            const error = response.data as IErrorResponse;
            throw new Error(error.message);
        }

        return response.data as IBlob;
    }

    async downloadFile(url: string): Promise<File> {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error();
        }

        const filename = url.split('/').pop()!;

        const blob = await response.blob();
        const file = new File([blob], filename, { type: blob.type });

        return file;
    }

    /**
     * @description Upload a file to the specified URL
     * @param {string} url The URL to upload the file to
     * @param {string} fileBase64 The base64 content of the file to be uploaded
     */
    async uploadFile(url: string, fileBase64: string): Promise<boolean> {
        // Decode Base64 string to binary data
        const byteCharacters = atob(fileBase64);
        const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "x-ms-blob-type": "BlockBlob",
            },
            body: byteArray,
        });

        return response.ok;
    }

}

const fileService = new FileService();
export default fileService;